module.exports = __webpack_public_path__ + "img/itsm-header.5b55ddf4.png";